const innerCursor = document.getElementsByClassName('cursor--outer');


const custom_cursor_area = document.getElementsByClassName('custom-cursor');

const moveCursor = (e) => {

	var containerX = custom_cursor_area[0].offsetLeft
	var containerY = custom_cursor_area[0].getBoundingClientRect().top;

	const mouseY = e.clientY - containerY;
	const mouseX = e.clientX - containerX;

	innerCursor[0].style.display = 'flex';
	innerCursor[0].style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
}


const hideCursor = () => {
	innerCursor[0].style.display = 'none';
}

if (innerCursor && custom_cursor_area) {

	for (let i = 0; i < innerCursor.length; i++) {
		custom_cursor_area[i].addEventListener('pointermove', moveCursor);
		custom_cursor_area[i].addEventListener('pointerout', hideCursor);
	}

}
